const government = {
    bidSectionCode: '标包编号',
    bidSectionName: '标包名称'
}
export default government
